import { Home } from '@/views/hydrostats';

export default {
    path: '/stats',
    component: () =>import('../layouts/default'),
    children: [
        { path: '', component: Home }
    ],
    meta: { requiresAuth: true }
};